<template>
  <div id="TripOrderDetails">
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" persistent v-if="tripOrderDialog"
              v-model="tripOrderDialog">
      <v-card style="background: #e9ecee">
        <v-toolbar style="box-shadow: 0 15px 40px -20px rgba(40,44,63,.15);">
          <v-btn icon @click="$emit('cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Order Details</v-toolbar-title>
        </v-toolbar>

        <v-card-text v-if="trip" class="mt-5">
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-card style="box-shadow: 0 15px 40px -20px rgba(40,44,63,.15);" class="pa-8 rounded-0">
                  <div>
                    <h2 class="font-weight-medium ">{{ trip.Order[0].Organization.name }}</h2>
                    <span v-if="trip.Order.length" class="grey--text">{{ trip.Order[0].orderNum }}</span>
                  </div>
                  <div class="mt-2">
                    <span class="caption grey--text text--darken-2">Trip Id</span>
                    <p>{{ trip.tripId }}</p>
                  </div>

                  <div class="mb-10" style="width: 50px; height: 2px; background: black"></div>

                  <template v-if="trip.Order.length">
                    <div>
                      <h4 class="font-weight-medium">Bill Detail</h4>
                    </div>

                    <div class="d-flex justify-space-between order-bill my-2">
                      <span class="grey--text">Amount</span>
                      <span class="grey--text"><span class="body-2">₹</span> {{ trip.Order[0].price.toFixed(2) }}</span>
                    </div>

                    <v-divider></v-divider>
                    <div class="d-flex justify-space-between order-bill my-2">
                      <span class="grey--text">CGST(2.5%)</span>
                      <span class="grey--text"><span class="body-2">₹</span> {{
                          (trip.Order[0].price * 2.5 / 100).toFixed(2)
                        }}</span>
                    </div>
                    <div class="d-flex justify-space-between order-bill my-2">
                      <span class="grey--text">SGST(2.5%)</span>
                      <span class="grey--text"><span class="body-2">₹</span> {{
                          (trip.Order[0].price * 2.5 / 100).toFixed(2)
                        }}</span>
                    </div>
                    <div class="d-flex justify-space-between order-bill my-2">
                      <span class="grey--text">Bill Amount</span>
                      <span class="grey--text"><span class="body-2">₹</span> {{
                          trip.Order[0].finalPrice.toFixed(2)
                        }}</span>
                    </div>
                    <div class="d-flex justify-space-between order-bill my-2">
                      <span class="grey--text">Previous Due Amount</span>
                      <span class="grey--text"><span class="body-2">₹</span> {{
                          trip.Order[0].previousDueAmount.toFixed(2)
                        }}</span>
                    </div>
                    <div class="my-5 " style="width: 100%; height: 2px; background: black"></div>

                    <div class="d-flex justify-space-between order-bill my-2">
                      <h5 class="font-weight-bold text-uppercase">Total Amount</h5>
                      <h5 class="font-weight-bold"><span class="body-2">₹</span> {{
                          trip.Order[0].finalPrice + trip.Order[0].Organization.totalDueAmount
                        }}</h5>
                    </div>
                    <div class="d-flex justify-space-between order-bill my-2">
                      <h5 class="font-weight-bold green--text text-uppercase">Collected Amount</h5>
                      <h5 class="font-weight-bold green--text"><span class="body-2">₹</span>
                        {{ trip.Order[0].colloectedAmount.toFixed(2) }}</h5>
                    </div>
                    <div class="d-flex justify-space-between order-bill my-2">
                      <h5 class="font-weight-bold red--text text--lighten-2 text-uppercase">Total Due Amount</h5>
                      <h5 class="font-weight-bold red--text text--lighten-2"><span class="body-2">₹</span> {{
                          ((trip.Order[0].finalPrice + trip.Order[0].previousDueAmount) -
                              trip.Order[0].colloectedAmount).toFixed(2)
                        }}</h5>
                    </div>

                  </template>

                </v-card>
              </v-col>
              <v-col cols="8">
                <div v-if="trip.Order.length">
                  <v-card style="box-shadow: 0 15px 40px -20px rgba(40,44,63,.15);" class="pa-5 mb-5 rounded-0"
                          :key="index" v-for="(orderItem, index) in trip.Order[0].OrderItems">
                    <div class="d-flex">
                      <div>
                        <v-img :src="imgWpx(orderItem.Product.image,200)" width="70"></v-img>
                      </div>
                      <div class="ml-4" style="width: 100%">
                        <h3 class="font-weight-medium">{{ orderItem.Product.displayName }}</h3>
                        <div class="mt-2 d-flex align-center justify-space-between">
                          <div class="d-flex">
                            <div>
                              <span class="caption grey--text text--darken-1">Quantity</span>
                              <p>{{ orderItem.quantity }}
                                {{ orderItem.quantity>1?(orderItem.Unit.unit==='Piece'?'Pieces':`${orderItem.Product.containerType}es`):orderItem.Product.containerType }}</p>
                            </div>
                            <div class="ml-10">
                              <span class="caption grey--text text--darken-1">Per Unit</span>
                              <p>{{ orderItem.perUnitPrice }} / {{ orderItem.Product.containerType }}</p>
                            </div>
                          </div>

                          <div class="float-right">
                            <h2 class="font-weight-medium"><span class="text-h6">₹</span> {{ orderItem.price }}</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </div>
                <div v-else class="mt-10 ml-10" style="width: 100px; height: 100px; background: white">No Orders Done
                  Yet.
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SUBSCRIBE_TRIP_ORDER_DETAILS_BY_ID } from '../../graphql/subscriptions/Trips'

export default {
  name: 'TripOrderDetails',
  props: {
    tripOrderDialog: { type: Boolean, default: false },
    tripDestinationId: { type: String, default: null },
    tripId: { type: String, default: null },
  },
  data () {
    return { trip: null, loggedInUser: JSON.parse(localStorage.user) }
  },
  apollo: {
    $subscribe: {
      Trips: {
        query: SUBSCRIBE_TRIP_ORDER_DETAILS_BY_ID, fetchPolicy: 'network-only',
        variables () { return { tripId: this.tripId, tripDestinationId: this.tripDestinationId } },
        skip () { return !this.tripId },
        result ({ data, loading }) {
          if (!loading) {
            this.trip = data.Trips[0]
          }
        },
      },
    },
  },
}
</script>

<style scoped>

</style>
